import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d191c26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jump-block" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "jump-icon" }
const _hoisted_4 = ["src"]

import rightIcon from '@/assets/my-credentails/right-arrow.svg'
import { ref } from 'vue'
import AppHost, { isApp } from '@/utils/app'
import wxHost from '@/utils/wx'
import { useRouter } from 'vue-router'
import { TOKENKEY } from '@/config/constant'
import { useUserPermissionVerify } from '@/compositions/useUserAuthPermission'

type JumpItemType = {
  name: string
  actionType: string
}


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  components: {},
  name: 'jump-block',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $router = useRouter()
const { beforeAuthOpenWxMiniProgramHandle } = useUserPermissionVerify()

const getStudyUrl = () => {
  // token
  let info = localStorage.getItem(TOKENKEY)
  return process.env.NODE_ENV === 'development'
    ? `https://xag-academy-dev.xa.com/#/?isBar=1&token=${info}`
    : `https://xag-academy.xa.com/#/?isBar=1&token=${info}`
}

const jumpItem = ref<Array<JumpItemType>>([
  {
    name: '前往极飞学园',
    actionType: 'goToXagStudy',
  },
  {
    name: '实体证办理进度查询',
    actionType: 'progressInquire',
  },
])

const jumpHandle = (item: JumpItemType) => {
  let url = ''
  switch (item.actionType) {
    case 'goToXagStudy':
      console.log('前往极飞学院')
      url = getStudyUrl()
      beforeAuthOpenWxMiniProgramHandle({
        id: 'gh_68b32d3107f6',
        path: `/pages/webView?url=${encodeURIComponent(url)}`,
        version: process.env.NODE_ENV === 'production' ? 0 : 1,
      })
      break
    case 'progressInquire':
      console.log('实体证办理进度查询')
      $router.push({
        name: 'credentials-progress-search',
      })
      break
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jumpItem.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["jump-item", { 'van-hairline--top': index }]),
        key: index,
        onClick: ($event: any) => (jumpHandle(item))
      }, [
        _createElementVNode("div", null, _toDisplayString(item.name), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", { src: _unref(rightIcon) }, null, 8, _hoisted_4)
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})